import React from 'react';
import { UserMembersList } from './components/user-members-list';
import { RouterProps } from 'app/components/enhancers/with-router';

interface UserMembersProps {
  params: { id: string};
  router: RouterProps;
}

export function UserMembers({ params, router }: UserMembersProps) {
  return <UserMembersList id={params.id} router={router} />;
}
